/** Persistent anonymous user id for Axiom logging and download attribution. */
export const MBM_USER_ID_COOKIE = 'mbm-user-id'

/** ~100 years — effectively permanent for returning visitors. */
export const MBM_USER_ID_MAX_AGE = 100 * 365 * 24 * 60 * 60

export function getMbmUserIdCookieOptions() {
  return {
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax' as const,
    maxAge: MBM_USER_ID_MAX_AGE,
  }
}
